module.exports = __webpack_public_path__ + "img/md_flow02.e1c4e4a0.png";